import { Images } from "../../utility/image"

export const ImageComponent = ({ staticImgSrc, dynamicURL = null, className, alt }) => {
    if (dynamicURL) {
        return (<img
            src={dynamicURL}
            className={className || ""} alt={alt} />)
    }
    if (staticImgSrc) {
        return (<img
            src={Images[staticImgSrc]}
            className={className || ""} alt={alt} />)
    }
}